  <advanced-filter (onSubmit)="applyFilter()" *ngIf="isCoLogin()"></advanced-filter>
  <app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>
  <wl-card heading="Review Inbox ({{totalCount}})" subheading1="{{subheading1}}" subheading2="{{subheading2}}"
    *ngIf="showReviewInboxDataTable">

    <wl-date-input (dateRangeSelected)="onDateRangeSelected($event)" *ngIf="!isCoLogin()"></wl-date-input>

    <span *ngIf="showSelectedDate && !isCoLogin()" class="datetext">&nbsp;&nbsp;{{selectedDate}}&nbsp;&nbsp;<img
        src="../../../assets/fontawesome-web/svgs/regular/rectangle-xmark.svg" class="h-15px"
        (click)="closeButtonClick()">
    </span>

    <wl-search-input (searchValueChanged)="onSearch($event)" [ngClass]="{'search': isCoLogin()}"></wl-search-input>
    <br>

    <!-- <p *ngIf="noUserFound" class="m-100px text-center font-size-15em">{{noUserFound}}</p> //uncomment this line-->

    <!-- <div *ngIf="!noUserFound" child-container class="table-responsive"> //uncomment ngIf -->

    <div child-container class="table-responsive">
      <table class="table table-hover ; padding:20px">
        <thead>
          <tr>
            <th class="w-10pct pl-20px">Sr. No.</th>
            <th class="w-10pct"> Customer ID<br>
            <th class="w-10pct">Mobile Number<br>
            <th class="w-10pct">Name of Applicant <br>
            <th class="w-10pct">Verification Status<br>
            <th class="w-10pct">Maker Action</th>
            <th class="w-10pct">Checker Action</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let user of allUsers;let i = index;">
            <td class="vertical-align-middle pl-20px">
              <!-- <p>{{10 *(pageId-1)+i+1}}</p>    -->
              <p>{{10 *(pageId-1)+i+1}}</p>
            </td>
            <td class="vertical-align-middle">
              <p>{{ user?.custId ? user.custId : '-' }}</p>
            </td>
            <td class="vertical-align-middle">
              <p>{{ (user?.mobile_no || user?.aadhar_details?.mobile_number) ? (user?.mobile_no || user?.aadhar_details?.mobile_number) : '-' }}</p>
            </td>
            <td class="vertical-align-middle">

              <p>{{(user?.profile?.first_name)? user.profile.first_name : ""}}</p>
            </td>


    
            <!-- Same five cases as before, shown as badges instead of a
                 run-on line. The two-role cases stack one badge per role. -->
            <td class="vertical-align-middle">

              <span *ngIf="user.checkerStatus ==='approved'"
                    class="vrj-badge vrj-badge-approved">Approved</span>

              <span *ngIf="user.checkerStatus ==='rejected'"
                    class="vrj-badge vrj-badge-rejected">Rejected</span>

              <span *ngIf="(user.makerStatus ==='pending' && user.checkerStatus ==='pending')"
                    class="vrj-badge vrj-badge-pending">Pending</span>

              <div *ngIf="(user.makerStatus ==='approved' && user.checkerStatus ==='pending')"
                   class="vrj-status">
                <span class="vrj-badge vrj-badge-approved">
                  <span class="vrj-badge-role">Maker</span>Approved
                </span>
                <span class="vrj-badge vrj-badge-pending">
                  <span class="vrj-badge-role">Checker</span>Pending
                </span>
              </div>

              <div *ngIf="(user.makerStatus ==='rejected' && user.checkerStatus ==='pending')"
                   class="vrj-status">
                <span class="vrj-badge vrj-badge-rejected">
                  <span class="vrj-badge-role">Maker</span>Rejected
                </span>
                <span class="vrj-badge vrj-badge-pending">
                  <span class="vrj-badge-role">Checker</span>Pending
                </span>
              </div>

            </td>
            
            <!-- Maker Action: actionable only while the maker is the one logged
                 in; a checker sees the maker's outcome read-only. -->
            <td class="text-left vertical-align-middle">

              <button *ngIf="approvalStage === 'maker' && user.makerStatus ==='pending'"
                      class="btn btn-warning btn-sm btn-red-custom" (click)="validateCustomer(user)">
                validate
              </button>

              <span *ngIf="approvalStage !== 'maker' && user.makerStatus ==='pending'"
                    class="vrj-badge vrj-badge-pending">Pending</span>

              <img *ngIf="user.makerStatus ==='approved'"
                   src="../../assets/svg/white/icons8-correct-40.png" alt="Approved">

              <img *ngIf="user.makerStatus ==='rejected'"
                   src="../../assets/svg/white/icons8-wrong-40.png" alt="Rejected">
            </td>

            <!-- Checker Action: actionable only while the checker is the one
                 logged in; a maker sees the checker's outcome read-only. -->
            <td class="text-left vertical-align-middle">

              <button *ngIf="approvalStage === 'checker' && user.checkerStatus ==='pending' && user.makerStatus !=='pending'"
                      class="btn btn-warning btn-sm btn-red-custom" (click)="validateCustomer(user)">
                validate
              </button>

              <span *ngIf="user.checkerStatus ==='pending' && (approvalStage !== 'checker' || user.makerStatus ==='pending')"
                    class="vrj-badge vrj-badge-pending">Pending</span>

              <img *ngIf="user.checkerStatus ==='approved'"
                   src="../../assets/svg/white/icons8-correct-40.png" alt="Approved">

              <img *ngIf="user.checkerStatus ==='rejected'"
                   src="../../assets/svg/white/icons8-wrong-40.png" alt="Rejected">
            </td>

  
          </tr>
        </tbody>

      </table>
    </div>

    <nav class="flex-center" *ngIf="totalPage>1 && !this.noUserFound" aria-label="Page navigation example">
      <ul class="pagination">
        <!-- limit - 10 -->
        <li *ngIf="page>3"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">Previous</a></li>
        <li *ngIf="page>2"><a (click)="getAllUsersPage(filter,roleId,offset - 20,10,page - 2)">{{page - 2}}</a></li>
        <li *ngIf="page>1"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">{{page - 1}}</a></li>
        <li class="page-item active"><a (click)="getAllUsersPage(filter,roleId,offset,10,page)">{{page}}</a></li>
        <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">{{page + 1}}</a>
        </li>
        <li *ngIf="page+1<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 20,10,page + 2)">{{page +
            2}}</a></li>
        <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">Next</a></li>
      </ul>
    </nav>

  </wl-card>



<link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
  integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p" crossorigin="anonymous" />